const steps = [
  {
    id: 1,
    title: 'Find Your Perfect Product',
    description:
      'Browse categories (electronics, appliances, etc.) or use the search bar.',
    tip: 'Pro Tip: Filter by vendor or manufacturer',
  },
  {
    id: 2,
    title: 'Choose Your Payment Plan',
    description: 'Select your preferred payment method.',
    options: [
      'Option 1: Pay upfront (traditional checkout).',
      'Option 2: Split payments (select 3-6-month plans at checkout).',
    ],
    example: 'Example: "A ₦300,000 fridge = 3 monthly payments of ₦100,000."',
  },
  {
    id: 3,
    title: 'Quick Approval & Checkout',
    description: 'No lengthy forms—approval in minutes.',
  },
  {
    id: 4,
    title: 'Enjoy Now, Pay Stress-Free',
    description: 'Items delivered ASAP; payments auto-debited monthly.',
    bonus: 'Manage plans anytime in your dashboard.',
  },
  {
    id: 5,
    title: 'Need Help?',
    description: 'Live chat support.',
  },
];

function BuyingGuidePolicy() {
  return (
    <section className="max-w-4xl mx-auto py-6 scroll-smooth">
      {steps.map((step) => (
        <div key={step.id} className="mb-10">
          {/* Numbered Heading */}
          <h2 className="text-xl font-semibold leading-tight md:text-xl">
            {step.id}. {step.title}
          </h2>

          {/* Optional tip as subheading */}
          {step.tip && (
            <p className="mt-2 text-base font-medium text-gray-500">
              {step.tip}
            </p>
          )}

          {/* Description */}
          {step.description && (
            <p className="mt-3 text-[15px] leading-relaxed text-gray-800">
              {step.description}
            </p>
          )}

          {/* Options list */}
          {step.options && (
            <ul className="mt-3 list-disc space-y-2 pl-6 text-[15px] leading-relaxed text-gray-800">
              {step.options.map((opt, i) => (
                <li key={i}>{opt}</li>
              ))}
            </ul>
          )}

          {/* Example box */}
          {step.example && (
            <div className="mt-3 rounded-lg bg-gray-50 p-3 text-[15px] text-gray-800">
              {step.example}
            </div>
          )}

          {/* Bonus box */}
          {step.bonus && (
            <div className="mt-3 rounded-lg border border-dashed border-gray-300 p-3 text-[15px] text-gray-800">
              <span className="font-medium">Bonus:</span> {step.bonus}
            </div>
          )}
        </div>
      ))}
    </section>
  );
}

export default BuyingGuidePolicy;
